import Pill from '@/components/ui/Pill'

import { Icon } from '@/icons/Icon'
import { cn } from '@/lib/utils'

type CourseCallToActionProps = {
  trustedBy?: string
  duration?: string
  price?: string
  checkoutUrl: string | null
}

export default function CourseCallToAction({
  trustedBy,
  duration,
  price,
  checkoutUrl,
}: CourseCallToActionProps) {
  return (
    <div className="mb-2 mt-8 flex flex-col gap-6 border-t border-gray-200 pt-8 sm:flex-row sm:items-center">
      {checkoutUrl ? (
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" aria-label="Buy Course">
          <Pill style="primary" size="large" as="span">
            Buy Course
          </Pill>
        </a>
      ) : (
        <Pill style="disabled" size="large" aria-disabled="true">
          Buy Course
        </Pill>
      )}

      <div className="flex flex-col gap-2.5 sm:flex-row sm:items-center sm:gap-8">
        {trustedBy && <CourseCallToActionItem icon="users" label="Trusted by" value={trustedBy} />}
        {duration && <CourseCallToActionItem icon="circle-half-dotted-clock" value={duration} />}
        {price && <CourseCallToActionItem icon="sack-dollar" value={price} />}
      </div>
    </div>
  )
}

export function CourseCallToActionItem({
  icon,
  label,
  value,
  theme = 'light',
}: {
  icon: string
  label?: string
  value: string
  theme?: 'dark' | 'light'
}) {
  return (
    <div
      className={cn(
        'flex gap-3.5 text-13 sm:items-center [&>p>span]:font-medium',
        theme === 'light'
          ? 'text-black/60 dark:text-white/60 [&>p>span]:text-black dark:[&>p>span]:text-white'
          : 'text-white/60 [&>p>span]:text-white',
      )}
    >
      <Icon name={icon} className="text-primary-500" />
      <p className="line-clamp-1">
        {label && label + ' '}
        <span>{value}</span>
      </p>
    </div>
  )
}
